import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { StartTargetSelectionModeEnum } from '@cue/data';

export type NavigationRouteParams = Partial<{
  originalUrl: string;
  locationId?: string;
  areaId: number;
  endAreaId: number;
  targetResourceId?: number;
  targetQrCodeId?: string;
  currentNavigationStepIdx?: number;

  //NAV V3
  startQrCodeId?: string;
  startResourceId?: number;
  kioskId?: string;
  deploymentId?: string;
  wantOnlyBarrierFreePaths: boolean;
  groupIdx?: number;
  directionIdx?: number;
  startSelectionMode: StartTargetSelectionModeEnum;
  targetSelectionMode: StartTargetSelectionModeEnum;
  qrCodeInNonNavigableArea: boolean;
  openedQrCodeId?: string;
  openedResourceId?: number;
  cmMode?: boolean;
  targetAreaId?: number;
  autoRefresh?: boolean;
  scanQr?: boolean;
}>;

export function extractFromRoute(activatedRoute: ActivatedRoute): Observable<NavigationRouteParams> {
  return activatedRoute.queryParams.pipe(
    map((value) => ({
      areaId: parseInt(value['areaId']),
      endAreaId: value['endAreaId'],
      targetQrCodeId: value['targetQrCodeId'],
      targetResourceId: value['targetResourceId'] != null ? Number.parseInt(value['targetResourceId']) : undefined,
    }))
  );
}

export function extractFromRouteInstant(activatedRouteSnapshot: ActivatedRouteSnapshot): NavigationRouteParams {
  return [activatedRouteSnapshot.queryParams].map((value) => ({
    areaId: value['areaId'] ? +value['areaId'] : null,
    endAreaId: value['endAreaId'],
    startQrCodeId: value['startQrCodeId'],
    startResourceId: value['startResourceId'],
    targetQrCodeId: value['targetQrCodeId'],
    targetResourceId: value['targetResourceId'] != null ? Number.parseInt(value['targetResourceId']) : undefined,
    kioskId: value['kioskId'],
    deploymentId: value['deploymentId'],
    wantOnlyBarrierFreePaths:
      value['wantOnlyBarrierFreePaths'] != null ? value['wantOnlyBarrierFreePaths'].toLowerCase() == 'true' : false,
    directionIdx: value['directionIdx'],
    groupIdx: value['groupIdx'],
    qrCodeInNonNavigableArea: value['qrCodeInNonNavigableArea']?.toLowerCase() == 'true',
    openedQrCodeId: value['openedQrCodeId'],
    openedResourceId: value['openedResourceId'],
    cmMode: value['cmMode'],
    targetAreaId: value['targetAreaId'],
    autoRefresh: value['autoRefresh'],
    scanQr: value['scanQr']?.toLowerCase() == 'true',
  }))[0];
}
